export default __webpack_public_path__ + "a28c42da38b1117e6f5067268ea2afe3.jpg";